export const SET_LOADING_MANAGER_STATE = 'SET_LOADING_MANAGER_STATE' as const;

export enum LOADING_STATE {
    NOT_LOADED = 'NOT_LOADED',
    LOADED = 'LOADED'
}
